const firebaseConfig = {
    apiKey: "AIzaSyDofA95R-lNEmq-gfDj84S4zm1cMEDCO8Y",
    authDomain: "doctors-portal-project-63a75.firebaseapp.com",
    projectId: "doctors-portal-project-63a75",
    storageBucket: "doctors-portal-project-63a75.appspot.com",
    messagingSenderId: "84708046877",
    appId: "1:84708046877:web:cc5ceecc0c8d7eb0fa2ef4"
  };

  export default firebaseConfig;